import ServiceBase from "./ServiceBase"

const resource = "/agreements"

export default
	{
		getAgreements(payload)
		{
			return ServiceBase.get(resource + "/list" + (payload.customerID ? "/" + payload.customerID : "/0") + (payload.status ? "/" + payload.status : "/0") + (payload.period ? "/" + payload.period : "/0"))
		},
		getAgreement(id)
		{
			return ServiceBase.get(resource + "/" + id)
		},
		updateAgreement(payload)
		{
			return ServiceBase.put(resource + "/" + payload.id, payload)
		},
		addAgreement(payload)
		{
			return ServiceBase.post(resource, payload)
		},
		deleteAgreement(id)
		{
			return ServiceBase.delete(resource + "/" + id)
		}
	}